module.exports = __webpack_public_path__ + "static/img/dialog-bg2.07524ef4.png";